// POST /appraisals with the duplicate-appraisal warn-and-confirm round trip.
export async function createAppraisalWithDupeCheck(api, body) {
  try {
    const { data } = await api.post('/appraisals', body);
    return data;
  } catch (e) {
    const r = e?.response?.data;
    if (e?.response?.status === 409 && r?.code === 'duplicate_appraisal') {
      if (!window.confirm(`${r.detail}\n\nCreate another one anyway?`)) return null;
      const { data } = await api.post('/appraisals', body, { params: { confirm_duplicate: true } });
      return data;
    }
    throw e;
  }
}

export const quoteTypeStatus = (qt) =>
  ((qt.quote_categories || []).some(c => c !== 'Appraisal') ? 'Quote Sent' : 'Client Data');

export const propertyLabel = (p) =>
  p ? `${p.property_address_num || ''} ${p.property_address_street || ''}${p.property_address_suburb ? `, ${p.property_address_suburb}` : ''}`.trim() : '';
